<template>
    <div class="chat_main scroll_bar">
        <div class="history_message">
            <p @click="getHistory" v-if="!loadStatus">{{ $t('historyChat') }}</p>
            <p v-if="loadStatus === 'loading'">{{ $t('loading') }}</p>
            <p v-if="loadStatus === 'end'">{{ $t('noHistory') }}</p>
        </div>
        <div class="message_item" v-for="item in chatList" :key="item.date">
            <!--            机器人 或者  人工客服-->
            <div v-if="(item.senderType === 2 || item.senderType === 3) && !item.sensitiveFlag && !item.sensitiveWords && !item.recallFlag"
                class="left_message">
                <div class="face" v-if="initData.avatar">
                    <img :src="item.faceUrl" /> {{ item.msgType }}
                </div>
                <div class="message">
                    <div class="send_name">{{ item.senderName }} {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}</div>
                    <div class="msg_div">
                        <!--  这里会有各种消息类型 -->
                        <div v-if="(item.msgType === 1 || !item.msgType) && item.docPattern !== 1" class="text_message">
                            <div v-html="item.msgContent"></div>
                            <div v-html="item.answer"></div>
                            <div class="guide" :style="{ color: initData.cusColor }" @click="guideSend(guide)"
                                :key="guide.id" v-for="(guide, $index) in item.suggestList"
                                v-html="$index + 1 + '.' + guide.question">
                            </div>


                        </div>
                        <!--  ceshi -->
                        <div class="menubar nopadding"
                            v-if="(item.msgType === 99) && item.docPattern !== 1 && item.menubar && item.menubar.length > 0 && item.showType == 3">
                            <div>
                                <div class="business-list-item" v-for="it in item.menubar" :key="it.id">
                                    <div class="business-list-inner-item" @click="chooseMenu(it)">
                                        <div class="item-img"><img :src="it.imgUrl">
                                        </div>
                                        <div class="item-text">{{ it.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="(item.msgType === 99) && item.docPattern !== 1" class="text_message white nopadding">
                            <el-row class="w400" :class="type == 2 ? '' : 'h240'">
                                <el-col :span="4">
                                    <img class="not-scroll-img" src="../../../static/image/wantToAsk.png"
                                        style="height: 100%;">
                                </el-col>
                                <el-col :span="20" class="pl10">
                                    <div class="type1" v-if="type == 2">
                                        <el-tabs v-model="activeName">
                                            <el-tab-pane :key="item.id" v-for="item in List" :label="item.name"
                                                :name="item.id">
                                                <div v-for="(guide, $index) in item.list" :key="guide.id + $index">
                                                    <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)" class="guide"
                                                        @click="chooseSend(guide)">
                                                        <p class="black" v-html="guide.questionName"></p>
                                                        <i class="fr el-icon-arrow-right"></i>
                                                    </div>
                                                </div>
                                                <div class="refreshbtn" @click="refreshFn(item.list)"
                                                    v-if="(item.list && item.list.length > 5)"><i
                                                        class="el-icon-refresh">换一批</i>
                                                </div>
                                            </el-tab-pane>
                                        </el-tabs>
                                    </div>
                                    <div v-if="type == 1">
                                        <div class="guide" :key="guide.id" v-for="(guide, $index) in List">
                                            <div v-if="(Math.ceil(($index + 1) / 5) == activeIndex)"
                                                @click="chooseSend(guide)">
                                                <p class="black" v-html="guide.questionName"></p>
                                                <i class="fr  el-icon-arrow-right"></i>
                                            </div>
                                        </div>
                                        <div class="refreshbtn" @click="refreshFn(List)" v-if="(List.length > 5)"><i
                                                class="el-icon-refresh">换一批</i>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <!--  多轮问题展示 -->
                        <div v-if="(item.msgType === 1 || item.msgType === 3 || !item.msgType) && item.docPattern === 1"
                            class="text_message">
                            <div v-if="(item.docNode && item.docNode.nodeType !== 3) || !item.docNode" v-html="item.answer">
                            </div>
                            <div v-if="item.docNode.nodeType === 3">
                                <Iframe :src="item.docNode.nodeContent"></Iframe>
                            </div>
                            <div class="guide series" @click="seriesProblem(guide)" :key="guide.id"
                                v-for="(guide, $index) in item.docNode.itemList" v-html="guide.itemContent"></div>
                        </div>
                        <div v-if="item.msgType === 2" class="image_message">
                            <img :src="item.msgContent" :alt="item.fileName" @click="showLargeImage(item)" />
                        </div>
                        <!--          机器人富文本-->
                        <div v-if="item.msgType === 3 && item.senderType === 3 && item.docPattern !== 1"
                            class="text_message">
                            <div v-html="item.msgContent || item.answer"></div>
                            <div v-if="item.robotSuggest">
                                <div class="guide" :style="{ color: initData.cusColor }" :key="guide.id"
                                    v-for="(guide, $index) in JSON.parse(item.robotSuggest)" @click="guideSend(guide)"
                                    v-html="$index + 1 + '.' + guide.question"></div>
                            </div>
                            <div v-if="item.suggestList">
                                <div class="guide" :style="{ color: initData.cusColor }" :key="guide.id"
                                    v-for="(guide, $index) in item.suggestList" @click="guideSend(guide)"
                                    v-html="$index + 1 + '.' + guide.question"></div>
                            </div>


                        </div>
                        <!--              人工富文本-->
                        <div v-if="item.msgType === 3 && item.senderType === 2 && item.docPattern !== 1"
                            class="card_message" @click="openCardUrl(item.msgContent)">
                            <img :src="JSON.parse(item.msgContent).picture" />
                            <div class="info">
                                <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                                <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                                <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                            </div>
                        </div>
                        <div v-if="item.msgType === 4" class="file_message">
                            <div class="file_icon">
                                <svg t="1617682401274" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="2051" width="32" height="32">
                                    <path
                                        d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                        fill="#bfbfbf" p-id="2052"></path>
                                </svg>
                            </div>
                            <div class="file_name">
                                <div>{{ item.fileName }}</div>
                                <div class="file_size">
                                    <span v-if="item.size">{{ item.size }}k</span>
                                    <a @click.prevent="newTab(item)">{{ $t('download') }}</a>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.msgType === 5" class="audio_message">
                            <audio :src="item.msgContent" controls></audio>
                        </div>
                        <div v-if="item.msgType === 6" class="video_message">
                            <video :src="item.msgContent" controls></video>
                        </div>
                        <div v-if="item.msgType === 7" class="goods_message">
                            <div class="goods_info">
                                <div class="goods_image">
                                    <img :src="JSON.parse(item.msgContent).imgUrl" alt="" />
                                </div>
                                <div class="goods_detail">
                                    <div class="goods_title">
                                        {{ JSON.parse(item.msgContent).title }}
                                    </div>
                                    <div class="goods_desc">
                                        {{ JSON.parse(item.msgContent).describe }}
                                    </div>
                                    <div class="goods_label">
                                        {{ JSON.parse(item.msgContent).label }}
                                    </div>
                                </div>
                            </div>
                            <div class="goods_action">
                                <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl">{{
                                    $t('showDetail')
                                }}</a>
                            </div>
                        </div>
                        <div v-if="item.msgType === 8" class="order_message">
                            <div class="goods_info">
                                <div class="goods_image">
                                    <img :src="JSON.parse(item.msgContent).imgUrl" alt="" />
                                </div>
                                <div class="goods_detail">
                                    <div class="goods_title">
                                        {{ JSON.parse(item.msgContent).title }}
                                    </div>
                                    <div class="goods_desc">
                                        {{ JSON.parse(item.msgContent).describe }}
                                    </div>
                                </div>
                            </div>
                            <div class="order_data">
                                <div>
                                    {{ $t('orderStatus') }}：<span>{{
                                        JSON.parse(item.msgContent).orderStatus
                                    }}</span>
                                </div>
                                <div>
                                    {{ $t('orderNumber') }}：<span>{{
                                        JSON.parse(item.msgContent).orderCode
                                    }}</span>
                                </div>
                                <div>
                                    {{ $t('orderTime') }} ：<span>{{
                                        JSON.parse(item.msgContent).orderTime
                                    }}</span>
                                </div>
                            </div>
                            <div class="goods_action">
                                <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl"> {{
                                    $t('showDetail')
                                }}</a>
                            </div>
                        </div>
                        <div v-if="item.msgType === 9 && item.msgContent" @click="clickCard(item)"
                            class="order_message card_message">
                            <div class="goods_info">
                                <div class="goods_image">
                                    <img :src="JSON.parse(item.msgContent).imgUrl" alt="" />
                                </div>
                                <div class="goods_detail">
                                    <div class="goods_title">
                                        {{ JSON.parse(item.msgContent).title }}
                                    </div>
                                    <div class="goods_desc">
                                        {{ JSON.parse(item.msgContent).subTitle }}
                                    </div>
                                </div>
                            </div>
                            <div class="goods_action">
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                            </div>
                        </div>
                        <!--                        知识评价-->
                        <div class="click-question" v-if="item.docId && initData.commentDocMode && item.disabled !== 2">
                            <span class="thump" :class="item.disabled === 0 ? 'active' : 'disable'"
                                @click="clickQuestion(item, 1)" :title="$t('thump')"></span>
                            <span class="top" :class="item.disabled === 1 ? 'active' : 'disable'"
                                @click="clickQuestion(item, 0)" :title="$t('top')"></span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="guide series fl ml10" @click="TransferBtn" v-show="item.showTransferBtn">
                <i class="el-icon-user"></i>
                {{
                    $t("transform")
                }}
            </div>
            <!--            用户-->
            <div v-if="item.senderType === 1" class="right_message">
                <div v-if="false" class="face">
                    <img :src="item.faceUrl" />
                </div>
                <div class="message">
                    <div class="send_name"> {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}</div>
                    <!--  {{ item.name || item.senderName }} -->
                    <!--   这里会有各种消息类型              -->
                    <div :style="{
                        background: `linear-gradient(to right,  ${initData.mainColor})`,
                        color: initData.kitTxcolor
                    }" v-if="item.msgType === 1" class="text_message" v-html="item.msgContent"></div>
                    <div v-if="item.msgType === 2" class="image_message">
                        <img :src="item.msgContent" :alt="item.name" @click="showLargeImage(item)" />
                    </div>
                    <div v-if="item.msgType === 3" class="card_message" @click="openCardUrl(item.msgContent)">
                        <img :src="JSON.parse(item.msgContent).picture" />
                        <div class="info">
                            <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                            <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                            <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                        </div>
                    </div>
                    <div v-if="item.msgType === 4" class="file_message">
                        <div class="file_icon">
                            <svg t="1617682401274" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="2051" width="32" height="32">
                                <path
                                    d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                    fill="#bfbfbf" p-id="2052"></path>
                            </svg>
                        </div>
                        <div class="file_name">
                            <div>{{ item.fileName }}</div>
                            <div class="file_size">
                                <span v-if="item.size">{{ item.size }}k</span>
                                <a @click.prevent="newTab(item)">{{ $t('download') }}</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.msgType === 5" class="audio_message">
                        <audio :src="item.msgContent" controls></audio>
                    </div>
                    <div v-if="item.msgType === 6" class="video_message">
                        <video :src="item.msgContent" controls></video>
                    </div>
                    <div v-if="item.msgType === 7" class="goods_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt="" />
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                                <div class="goods_label">
                                    {{ JSON.parse(item.msgContent).label }}
                                </div>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl">{{ $t('showDetail') }}</a>
                        </div>
                    </div>
                    <div v-if="item.msgType === 8" class="order_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt="" />
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                            </div>
                        </div>
                        <div class="order_data">
                            <div>
                                {{ $t('orderStatus') }}：<span>{{
                                    JSON.parse(item.msgContent).orderStatus
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderNumber') }}：<span>{{
                                    JSON.parse(item.msgContent).orderCode
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderTime') }}：<span>{{
                                    JSON.parse(item.msgContent).orderTime
                                }}</span>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl">{{ $t('showDetail') }}</a>
                        </div>
                    </div>
                    <i v-if="item.status === 'loading'" class="el-icon-loading status"></i>
                    <i v-if="item.status === 'failed'" class="el-icon-warning status"></i>
                </div>
            </div>
            <!--            系统消息-->
            <div v-if="item.senderType === 4 || (!item.senderType && !item.senderName && item.msgType != 998)"
                class="system_message">
                <span v-if="item.clientType == 2" class="normal" v-html="item.msgContent"></span>
                <span v-else-if="item.clientType != 1" :class="item.type === 1 ? 'normal' : 'bg'"
                    v-html="item.msgContent"></span>
            </div>
            <!--    超时信息-->
            <div v-if="!item.senderType && item.senderName" class="left_message">
                <div class="face" v-if="initData.avatar">
                    <img :src="item.faceUrl" /> {{ item.msgType }}
                </div>
                <div class="message">
                    <div class="send_name">{{ item.senderName }} {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}</div>
                    <div class="msg_div">
                        <div class="text_message">
                            <div v-html="item.msgContent"></div>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="item.msgType === 'card'" class="card_center">
                <div class="card_message">
                    <img :src="item.picture">
                    <div class="info">
                        <div class="title">{{ item.title }}</div>
                        <div class="desc">{{ item.desc }}</div>
                        <div class="price">{{ item.price }}</div>
                        <span class="send_card" @click="sendObj(item)">发送客服</span>
                    </div>
                </div>
            </div>
        </div>
        <span v-scroll-bottom="scrollBottom" class="scroll_auto scroll-bottom scroll_iframe_auto_bottom"></span>
        <el-drawer direction="rtl" ref="groupDrawer" :with-header="true" :modal="false" :size="'240px'"
            :visible.sync="showGroup" :show-close="showCloseBtn" :before-close="beforeClose">
            <div class="group_border" v-if="!showFormChat">
                <div class="group_item" @mouseenter="setColor" @mouseleave="resetColor"
                    :style="{ border: `1px solid ${initData.kitBgcolor}` }" v-for="group in channelGroup" :key="group.id"
                    @click="selectGroup(group)">
                    {{ group.groupName }}
                </div>
            </div>
            <div class="form_user" v-if="showFormChat">
                <p>{{ initData.userForm ? initData.userForm.formTitle : '' }}</p>
                <div v-for="item in formData.formList" v-if="item.show">
                    <span class="label"> <span class="red" v-if="item.require">*</span>{{ item.name }}</span>
                    <el-input :maxLength="16" v-model="item.value" type="text" :placholder="$t('input')" />
                </div>
                <el-button @click="submitForm" :style="{ background: `linear-gradient(to right, ${initData.mainColor})` }"
                    type="default" size="normal">
                    {{ $t('submit') }}
                </el-button>
            </div>

        </el-drawer>
        <el-drawer size="100%" :append-to-body="true" :with-header="false" direction="ttb" :visible.sync="showImage">
            <div class="img_border" @click="showImage = !showImage">
                <img :src="largeImageUrl" class="largeImage" />
            </div>
        </el-drawer>
    </div>
</template>

<script>
import chatApi from "../methods";
import store from "../../store";
import { Toast } from "mint-ui";

export default {
    name: "chatpc",
    data() {
        return {
            showImage: false,
            largeImageUrl: "",
            showGroup: false,
            showCloseBtn: false,
            formData: {},
            activeName: '',
            activeIndex: 1,
            menubar: [],
            type: 1,
            List: []
        };
    },
    computed: {
        showFormChat() {
            return this.$store.state.showFormChat;
        },
        chatList() {
            return this.$store.state.chatList;
        },
        scrollBottom() {
            return this.$store.state.scrollBottom;
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        showChannelGroup() {
            this.showGroup = this.$store.state.showChannelGroup;
        },
        channelGroup() {
            return this.$store.state.channelGroup;
        },
        initData() {
            try {
                if (this.$store.state.initData.userForm) {
                    this.formData = JSON.parse(JSON.stringify(this.$store.state.initData.userForm));
                }
                if (this.$store.state.initData.faq) {
                    var content = JSON.parse(this.$store.state.initData.faq.showContent);
                    if (this.$store.state.initData.faq.showType == 3) {
                        if (content[0].type == 1) {
                            this.List = content[0].questionList || [];
                        } else if (content[0].type == 2) {
                            this.List = content[0].faqGrouplist || [];
                        }
                        this.type = content[0].type
                    } else if (this.$store.state.initData.faq.showType == 2) {
                        this.List = content;
                        this.type = 2;
                        this.activeName = content[0].id;
                    } else {
                        this.List = content;
                        this.type = 1;
                    }

                }

            } catch (e) {
            }
            return this.$store.state.initData;
        },
        connectStatus() {
            return this.$store.state.connectStatus;
        },
    },
    watch: {
        activeName() {
            this.activeIndex = 1;
        },
        initData() {

            return this.$store.state.initData;
        },
        chatList() {
            if (this.$store.state.userInfo.status === 0) {
                //未建立会议
                console.log('chat session not yet')
            }
        },
        scrollBottom() {
            setTimeout(() => {
                document.getElementsByClassName("scroll-bottom")[0].scrollIntoView();
            }, 100);
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        showChannelGroup() {
            return this.$store.state.showChannelGroup;
        },
        channelGroup() {
            return this.$store.state.channelGroup;
        },

        showGroup() {
            if (this.initData.receiveMode == 3) {
                this.showCloseBtn = false;
            } else {
                this.showCloseBtn = true;
            }
            if (!this.showGroup) {
                //receiveMode
                this.$store.dispatch("setShowChannelGroup", false);
            }
        },
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return ''
            }
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt;
        },
        submitForm() {
            for (let i = 0; i < this.formData.formList.length; i++) {
                if (this.formData.formList[i].require && this.formData.formList[i].show && !this.formData.formList[i].value) {
                    Toast({
                        message: this.$t('pleInput') + `${this.formData.formList[i].name}` + this.$t('content'),
                        duration: 3000
                    });
                    return
                }
            }
            let phoneFormat = /^1[0-9]{10}$/;
            if (this.formData.formList[1].value && !phoneFormat.test(this.formData.formList[1].value)) {
                Toast({
                    message: this.$t('rightPhone'),
                    duration: 3000
                });
                return
            }
            let formatEmail = /^[a-zA-Z0-9]+([-_\.][a-zA-Z0-9]+)*(?:@(?!-))(?:(?:[a-zA-Z0-9-]*)(?:[a-zA-Z0-9](?!-))(?:\.(?!-)))+[a-zA-Z]{2,}$/
            if (this.formData.formList[2].value && !formatEmail.test(this.formData.formList[2].value)) {
                Toast({
                    message: this.$t('rightEmail'),
                    duration: 3000
                });
                return
            }
            let data = {
                userName: this.formData.formList[0].value,
                phone: this.formData.formList[1].value,
                email: this.formData.formList[2].value,
            }
            chatApi.submitUserForm(data)
        },
        clickCard(item) {
            try {
                let obj = JSON.parse(item.msgContent);
                //跳转工单模板
                if (obj.linkType) {
                    let url = location.origin + '/chat_online/formData?tenantId=' + store.state.initData.tenantId + '&templateId=' + obj.linkUrl
                    window.open(url)
                } else {
                    window.open(obj.linkUrl, '_blank')
                }
            } catch (e) {

            }

        },
        setColor(e) {
            // e.target.style.backgroundColor = this.initData.kitBgcolor;
            // e.target.style.color = "white";
        },
        resetColor(e) {
            // e.target.style.backgroundColor = "";
            // e.target.style.color = "white";
        },
        // 图片点击放大
        showLargeImage(img) {
            if (img.msgContent) {
                this.showImage = true;
                this.largeImageUrl = img.msgContent;
            }
        },
        clickQuestion(data, type) {
            if (data.disabled === 1 || data.disabled === 0) {
                return
            }
            chatApi.evaluateKb({ docId: data.docId, isUseful: type }, () => {
                store.dispatch('updateChatItemClick', { type, time: data.msgTime })
            })
        },
        // 历史记录
        getHistory() {
            store.dispatch("setLoadingStatus", "loadStart");
            const param = {
                pageSize: 20,
                maxTime: 0,
            };
            chatApi.getHistoryList(param);
        },
        // 点击引导问题
        guideSend(guide) {
            const obj = {
                docId: guide.docId,
                click: 1,
                msgContent: guide.question,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // 点击多轮问题
        seriesProblem(guide) {
            const obj = {
                docId: guide.docId,
                nodeId: guide.nodeId,
                itemId: guide.itemId,
                click: 1,
                msgContent: guide.itemContent,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        //发送对象 商品  订单 。。。
        sendObj(obj) {
            chatApi.sendJson(obj)
        },
        openCardUrl(item) {
            try {
                let obj = JSON.parse(item)
                if (obj.url) {
                    window.open(obj.url, '_blank')
                }
            } catch (e) {
            }
        },
        // 点击技能组
        selectGroup(group) {
            this.$store.dispatch("setShowChannelGroup", false);
            chatApi.transfer(group);
        },
        newTab(msg) {
            const a = document.createElement("a");
            a.href = msg.msgContent;
            a.download = msg.fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        beforeClose(done) {
            if (this.initData.receiveMode !== 3) {
                done();
            }
        },
        chooseMenu(item) {
            if (item.type == 2) {
                this.activeName = item.faqGrouplist[0].id;
                this.List = item.faqGrouplist
            } else if (item.type == 1) {
                this.List = item.questionList;
            } else {
                window.open(item.labelLink, "_blank");
                return;
            }
            this.type = item.type;
            // this.imgUrl = item.imgUrl;
            this.activeIndex = 1;
        },
        refreshFn(item) {
            this.activeIndex = this.activeIndex < (Math.ceil(item.length / 5)) ? this.activeIndex + 1 : 1;
        },
        chooseSend(row) {
            const obj = {
                click: 1,
                msgContent: row.questionName,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        TransferBtn() {
            chatApi.chatForm();
        }
    },
    directives: {
        // 发送消息后滚动到底部
        "scroll-bottom"(el) {
            setTimeout(() => {
                // el.scrollIntoView();
            }, 100);
        },
    },
    mounted() {
        try {
            setTimeout(() => {
                let div = document.querySelector(".message_item")
                if (div) {
                    div.onclick = function (e) {
                        const link = e.target.getAttribute("data-link");
                        if (link) {
                            window.open(link);
                        }
                    };
                }

            }, 400)
        } catch (e) {
        }

    }
};
</script>

<style scoped>
.form_user button {
    color: #ffffff;
    font-size: 14px;
    width: 100%;
}

.card_center {
    text-align: center;
}

.card_center .card_message {
    margin: 0 auto;
    border-radius: 10px;
    position: relative;

}

.card_center .send_card {
    position: absolute;
    bottom: 10px;
    right: 12px;
    padding: 2px 4px;
    font-size: 12px;
    border: 1px solid #7467f0;
    border-radius: 4px;
    color: #7467f0;

}

.card_center .card_message .info {
    width: 250px;

}

.form_user {
    margin: 15px 20px;
    font-size: 14px;
}

.form_user div .label {
    display: block;
    padding-left: 5px;
    width: 60px;
    text-align: left;
    color: #747070
}

.form_user div input {
    display: inline-block;
    width: 70%;
    height: 35px;
    outline: none;
    color: #565656;
    border-radius: 3px;
    padding: 3px;
}

.form_user div {
    margin: 0px auto 6px;
}

.form_user p {
    margin: 15px 5px 25px;
    font-size: 14px;
    text-align: left;
    color: #6f6f6f;
}

.history_message p {
    color: #999999;
    cursor: pointer;
    margin: 4px;
}

.chat_main {
    /*height: 415px;*/
    height: calc(100% - 230px);
    /* border-top: 0.5px solid #e6e6e6; */
}

.message {
    position: relative;
    max-width: 100%;
    word-break: break-word;
}

.msg_div {
    position: relative;
    display: inline-block;
    max-width: 100%;
}

.message .click-question {
    display: block;
    text-align: right;
    padding: 0;
    margin-top: 5px;
    position: absolute;
    right: -30px;
    bottom: 0px;
    height: 50px;
    width: 28px;
}

.message .click-question span {
    display: block;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background-size: 100% 100%;
    margin: 4px;
}

.message .click-question .thump {
    background-image: url("../../../static/image/updisable.png");
}

.message .click-question .top {
    background-image: url("../../../static/image/downdisable.png");
}

.message .thump.active {
    background: none;
}

.message .top.active {
    background: none;
}

.guide {
    line-height: 30px;
    cursor: pointer;
}

.series {
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    margin: 5px;
    overflow: hidden;
    max-width: 130px;
    height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #7467f0;
    background-color: white;
}

.series:hover {
    background: #f3f3f3;
    color: #596788;
}

.msg_div>div {
    border-radius: 0 10px 10px 10px;
    padding: 10px 15px 8px;
    display: inline-block;
    max-width: 100%;
}

.right_message .message>div {
    border-radius: 10px 0 10px 10px;
    max-width: 100%;
}

.right_message .text_message {
    border-radius: 10px 0 10px 10px;

}

.right_message .text_message a {
    color: white;
}

.message .status {
    font-size: 16px;
    bottom: 0;
    color: #999;
}

.message .el-icon-warning {
    color: red;
}

.message .send_name {
    padding: 3px 5px;
    display: block;
    max-width: 250px;
}

.image_message {
    border: 1px solid #cbcbcb;
}

.image_message img {
    width: auto;
    max-width: 200px;
}

.file_message {
    display: flex;
    padding: 10px;
    background: #f6f6f6;
    border: 1px solid #dcdcdc;
}

.audio_message {
    border: 1px solid #dcdcdc;
}

.file_name {
    text-align: left;
    /*background-image: url("../../../static/image/icon_ui.png");*/
}

.file_size {
    position: relative;
}

.file_size a {
    color: #7063ed;
    text-decoration: none;
    position: absolute;
    right: 4px;
}

.card_message {
    border: 1px solid #e6e6e6;
    padding: 15px;
    cursor: pointer;
}

.card_message img {
    width: 65px;
    height: 65px;
    vertical-align: middle;
}

.card_message .info {
    display: inline-block;
    vertical-align: middle;
    width: 170px;
    margin: 0 10px;
    height: 65px;
}

.info .title,
.price {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

.info .title {
    font-size: 14px;
    font-weight: 600;
}

.info .desc {
    font-size: 12px;
    color: #666;
    text-align: left;
    height: 34px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.info .price {
    color: #7467f0;
    font-size: 12px;
}

video {
    width: auto;
    max-width: 80%;
}

audio {
    height: 40px;
    outline: none;
}

.el-drawer__wrapper {
    position: absolute;
}

.group_border {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px 0;
}

.group_item {
    line-height: 25px;
    width: 80%;
    border: 1px solid gainsboro;
    margin: 6px auto;
    cursor: pointer;
    border-radius: 3px;
    padding: 3px 0;
    color: #777777;
}

.group_item:hover {
    /* color: var(--active-color, '#dc') */
}

.group_item:active {
    /* color: white !important; */
}

.el-drawer__body {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.img_border {
    position: fixed;
    width: 100%;
    height: 100%;
}

.img_border img {
    max-width: 85%;
    max-height: 90%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    bottom: 0;
}

Iframe {
    border: none;
    width: 100%;
}

.goods_message,
.order_message {
    border: 1px solid #e0e0e0;
}

.goods_info {
    display: flex;
}

.card_message .goods_info .goods_image {
    max-width: 140px;
    min-width: 140px;
}

.card_message .goods_action {
    border: none
}

.card_message .goods_info .goods_detail {
    flex: 1;
}

.card_message .goods_info .goods_image img {
    width: 130px;
    height: 130px;
}

.goods_info>div,
.order_message>div {
    vertical-align: middle;
}

.goods_image img {
    width: 110px;
    height: 110px;
    display: inline-block;
    overflow: hidden;
    border-radius: 2px;
}

.goods_detail {
    width: 220px;
    height: 110px;
    display: inline-block;
}

.goods_title {
    font-size: 16px;
    font-weight: 600;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: 44px;
    text-align: left;
    padding: 1px 7px;
}

.goods_desc {
    text-align: left;
    line-height: 30px;
    font-size: 14px;
    padding: 0 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.card_message .goods_desc {
    text-align: left;
    margin-top: 10px;
    line-height: 20px;
    font-size: 14px;
    padding: 0 7px;
    overflow: auto;
    white-space: inherit;
    text-overflow: initial;
}

.goods_label {
    text-align: left;
    line-height: 30px;
    font-size: 16px;
    padding: 0 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #7467f0;
}

.goods_action {
    width: 97%;
    text-align: center;
    padding-top: 15px;
    border-top: 1px solid gainsboro;
    margin: 10px auto;
}

.goods_action a {
    text-decoration: none;
    font-size: 14px;
    color: #7467f0;
    display: inline-block;
    width: 100px;
    border: 1px solid #7467f0;
    padding: 5px;
    line-height: 25px;
    border-radius: 20px;
}

.order_data {
    text-align: center;
    line-height: 25px;
    color: #545454;
    font-size: 14px;
    width: 80%;
    margin: 10px auto;
}

.order_data span {
    display: inline-block;
    width: 140px;
    text-align: left;
    color: #7467f0;
}

.largeImage {
    width: auto;
}

.w400 {
    width: 400px;
    height: 294px;
    position: relative;
}

.h240 {
    width: 400px;
    height: 244px;
    position: relative;
}

.nopadding {
    padding: 0 !important;
}

.pl10 {
    padding-left: 10px;
}

.item-img {
    width: 36px;
    height: 36px;
    margin-bottom: 10px;
}

.item-text {
    width: 56px;
    height: 22px;
    color: #161616;
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    text-align: center;
}

.business-list-inner-item {
    cursor: pointer;
    width: 70px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 10%);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 0 10px;
    margin: 0 4px;
    align-items: center;
    touch-action: pan-x;
}

.business-list-item {
    display: inline-block;
    vertical-align: middle;
    width: 70px;
    margin: 0 10px 10px 0;
}

.menubar {
    white-space: pre-line;
    color: #333333;
    line-height: 20px;
    font-size: 14px;
    text-align: left;
    display: block !important;
    ;
}

.type1 /deep/ .el-tabs__content {
    height: 238px;
}

.type1 /deep/ .el-tabs__nav-next {
    top: 14px
}

.type1 /deep/ .el-tabs__nav-prev {
    top: 14px
}

.refreshbtn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    color: #a3a5a8;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 320px;
}

.guide {
    margin: 10px 0 0 5px;
}

.fr {
    position: absolute;
    margin-top: -24px;
    margin-left: 260px;
    color: #000;
}

.text_message {
    background: #f5f5f5;
    font-family: "Microsoft Yahei", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.black {
    color: #000;
}

.white {
    background: #ffffff;
}

.fl {
    float: left;
}

.ml10 {
    margin-left: 10px;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/chatpc.vue